module.exports = __webpack_public_path__ + "static/media/firebase-og.2795f15c.svg";